import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-[#1B2A4A] text-white" data-id="element-132">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-24" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-134">
          <div className="flex justify-center mb-8" data-id="element-135">
            <ShieldCheckIcon className="w-20 h-20 text-[#C9A84C]" data-id="element-136" />
          </div>

          <h2 className="text-3xl sm:text-4xl font-bold mb-6" data-id="element-137">
            Tu Garantía Total de 30 Días
          </h2>

          <p className="text-xl text-gray-200 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-138">
            El riesgo lo corremos nosotros. Si demuestras implementación y no
            estás conforme con el producto, tienes un plazo de 30 días para
            solicitar reembolso. Sin preguntas y sin complicaciones, te
            devolvemos tu dinero.
          </p>

          <p className="text-2xl font-bold text-[#C9A84C]" data-id="element-139">
            No tienes nada que perder. Y una ciudadanía que ganar.
          </p>
        </motion.div>
      </div>
    </section>;
}